module.exports = __webpack_public_path__ + "static/media/SIMF.9daaf453.png";